module.exports = __webpack_public_path__ + "img/T7A6663.23ddfc08.jpg";